import { FC, useState } from 'react';
import { Button, Col, Form, Input, Row, Select, Space, Table } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import FleetTitle from '@/libs/antd/components/Title';
import { useQuery } from '@tanstack/react-query';
import { getFRMCallReportList } from '@/libs/fleet-api/services/visit-reports';
import { useApp } from '@/App';
import { useModals } from '@/components/modals/ModalProvider';
import { FleetGetListParams } from '@/libs/fleet-api/fetcher';

const FRMCallReportListPage: FC = () => {
	const { openCustomerDetail } = useModals();
	const { navigate } = useApp();
	const [params, setParams] = useState<FleetGetListParams>({
		pagination: {
			pageNumber: 1,
			pageSize: 10,
		},
	});

	const { data, isFetching } = useQuery({
		queryKey: [
			'getFRMCallReportList',
			params.pagination,
			params.search,
		] as const,
		queryFn: ({ queryKey }) => {
			const [, pagination, search] = queryKey;
			return getFRMCallReportList({
				pagination,
				search,
			});
		},
	});

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<FleetTitle>List Call Report</FleetTitle>

			<Form
				layout="horizontal"
				colon={false}
				labelAlign="left"
				onFinish={(params) => {
					setParams({
						pagination: {
							pageNumber: 1,
							pageSize: 10,
						},
						...params,
					});
				}}
			>
				<Row gutter={[20, 20]}>
					<Col flex="auto">
						<Form.Item
							name={['search', 'by']}
							label={<span>Search By</span>}
							labelCol={{ flex: 'auto' }}
							wrapperCol={{ flex: 'none', style: { width: 250 } }}
							initialValue="customer-name"
						>
							<Select
								placeholder="Search By"
								options={[
									{
										label: 'Customer Name',
										value: 'customer-name',
									},
									// {
									// 	label: 'NPWP',
									// 	value: 'npwp',
									// },
									// {
									// 	label: 'Status',
									// 	value: 'status',
									// },
								]}
								style={{
									display: 'block',
									width: '100%',
								}}
							/>
						</Form.Item>
					</Col>
					<Col style={{ width: 300 }}>
						<Form.Item name={['search', 'value']}>
							<Input
								placeholder="Search..."
								style={{
									display: 'block',
								}}
							/>
						</Form.Item>
					</Col>
					<Col>
						<Form.Item>
							<Button
								block
								type="primary"
								htmlType="submit"
							>
								SEARCH
							</Button>
						</Form.Item>
					</Col>
				</Row>
			</Form>

			<Table
				scroll={{ x: 'max-content' }}
				bordered
				dataSource={
					data?.data.items.map((data, i) => {
						return {
							...data,
							key: data.prospectId + i,
						};
					}) ?? []
				}
				loading={isFetching}
				columns={[
					{
						title: 'No',
						width: 1,
						align: 'center',
						render: (_, __, i) => {
							const { pageNumber, pageSize } = params.pagination;
							return pageSize * (pageNumber - 1) + (i + 1);
						},
					},
					{
						title: 'Prospect ID',
						render: (_, record) => record.prospectId,
					},
					{
						title: 'Nama Customer',
						render: (_, record) => (
							<a
								href="#"
								onClick={(e) => {
									e.preventDefault();
									openCustomerDetail(record.customerId);
								}}
							>
								{record.customerName}
							</a>
						),
					},
					{
						title: 'Jenis Plafon',
						render: () => '-',
					},
					{
						title: 'Group  BMPP',
						render: (_, record) => record.customerGroup.value,
					},
					{
						title: 'Department',
						render: () => '-',
					},
					{
						title: 'Fleet RM',
						render: (_, record) => record.frmName,
					},
					{
						title: 'Sektor Industri',
						render: (_, record) => record.industrySector.sectorLevel5,
					},
					{
						title: 'Detail Call Report',
						align: 'center',
						fixed: 'right',
						render: (_, { prospectId }) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('FRMCallReportHistoryPage', {
											prospectId,
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							);
						},
					},
				]}
				pagination={{
					current: params.pagination.pageNumber,
					pageSize: 10,
					total: data?.data.totalCount,
					showSizeChanger: false,
					onChange: (pageNumber) => {
						setParams((params) => {
							return {
								...params,
								pagination: {
									...params.pagination,
									pageNumber,
								},
							};
						});
					},
				}}
			/>
		</Space>
	);
};

export default FRMCallReportListPage;
